/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：863
 */

module.exports = function (e, t) {
  return e === t || e !== e && t !== t
}
